import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, autorun, computed, makeObservable, observable, runInAction } from "mobx";
import Cartesian2 from "terriajs-cesium/Source/Core/Cartesian2";
import EasingFunction from "terriajs-cesium/Source/Core/EasingFunction";
import Scene from "terriajs-cesium/Source/Scene/Scene";
import SceneTransforms from "terriajs-cesium/Source/Scene/SceneTransforms";
import locationTargetIcon from "../../../wwwroot/images/NM-LocationTarget.svg";
import isDefined from "../../Core/isDefined";
const screenSpacePos = new Cartesian2();
const offScreen = "-1000px";
let CesiumSelectionIndicator = (_class = class CesiumSelectionIndicator {
  constructor(cesium) {
    /**
     * Gets or sets the world position of the object for which to display the selection indicator.
     * @type {Cartesian3}
     */
    _initializerDefineProperty(this, "position", _descriptor, this);
    /**
     * Gets or sets the visibility of the selection indicator.
     * @type {Boolean}
     */
    _initializerDefineProperty(this, "showSelection", _descriptor2, this);
    _initializerDefineProperty(this, "transform", _descriptor3, this);
    _initializerDefineProperty(this, "opacity", _descriptor4, this);
    _defineProperty(this, "container", void 0);
    _defineProperty(this, "selectionIndicatorElement", void 0);
    _defineProperty(this, "scene", void 0);
    _initializerDefineProperty(this, "_screenPositionX", _descriptor5, this);
    _initializerDefineProperty(this, "_screenPositionY", _descriptor6, this);
    _defineProperty(this, "_cesium", void 0);
    _defineProperty(this, "_tweens", void 0);
    _defineProperty(this, "_selectionIndicatorTween", void 0);
    _defineProperty(this, "_selectionIndicatorIsAppearing", false);
    _defineProperty(this, "_disposeAutorun", void 0);
    makeObservable(this);
    this._cesium = cesium;
    this._tweens = cesium.scene.tweens;
    this.container = cesium.cesiumWidget.container;
    this.scene = cesium.scene;
    const el = document.createElement("div");
    el.className = "selection-indicator";
    this.container.appendChild(el);
    this.selectionIndicatorElement = el;
    const img = document.createElement("img");
    img.setAttribute("src", locationTargetIcon);
    img.setAttribute("alt", "");
    img.setAttribute("width", "50px");
    img.setAttribute("height", "50px");
    el.appendChild(img);
    this._disposeAutorun = autorun(() => {
      el.style.top = this._screenPositionY;
      el.style.left = this._screenPositionX;
      el.style.transform = this.transform;
      el.style.opacity = this.opacity.toString();
    });
  }
  destroy() {
    if (this.selectionIndicatorElement.parentNode) {
      this.selectionIndicatorElement.parentNode.removeChild(this.selectionIndicatorElement);
    }
    this._disposeAutorun();
  }

  /**
   * Gets the visibility of the position indicator.  This can be false even if an
   * object is selected, when the selected object has no position.
   * @type {Boolean}
   */
  get isVisible() {
    return this.showSelection && isDefined(this.position);
  }

  /**
   * Updates the view of the selection indicator to match the position and content properties of the view model.
   * This function should be called as part of the render loop.
   */
  update() {
    if (this.showSelection && isDefined(this.position)) {
      const screenPosition = SceneTransforms.worldToWindowCoordinates(this._cesium.scene, this.position, screenSpacePos);
      if (!isDefined(screenPosition)) {
        this._screenPositionX = offScreen;
        this._screenPositionY = offScreen;
      } else {
        const container = this.container;
        const containerWidth = container.clientWidth;
        const containerHeight = container.clientHeight;
        const indicatorSize = this.selectionIndicatorElement.clientWidth;
        const halfSize = indicatorSize * 0.5;
        screenPosition.x = Math.min(Math.max(screenPosition.x, -indicatorSize), containerWidth + indicatorSize) - halfSize;
        screenPosition.y = Math.min(Math.max(screenPosition.y, -indicatorSize), containerHeight + indicatorSize) - halfSize;
        this._screenPositionX = Math.floor(screenPosition.x + 0.25) + "px";
        this._screenPositionY = Math.floor(screenPosition.y + 0.25) + "px";
      }
    }
  }

  /**
   * Animate the indicator to draw attention to the selection.
   */
  animateAppear() {
    if (isDefined(this._selectionIndicatorTween)) {
      if (this._selectionIndicatorIsAppearing) {
        // Already appearing; don't restart the animation.
        return;
      }
      this._selectionIndicatorTween.cancelTween();
      this._selectionIndicatorTween = undefined;
    }
    this._selectionIndicatorIsAppearing = true;
    this._selectionIndicatorTween = this._tweens.add({
      startObject: {
        scale: 2.0,
        opacity: 0.0,
        rotate: -180
      },
      stopObject: {
        scale: 1.0,
        opacity: 1.0,
        rotate: 0
      },
      duration: 0.8,
      easingFunction: EasingFunction.EXPONENTIAL_OUT,
      update: value => {
        runInAction(() => {
          this.opacity = value.opacity;
          this.transform = "scale(" + value.scale + ") rotate(" + value.rotate + "deg)";
        });
      },
      complete: () => {
        this._selectionIndicatorTween = undefined;
      },
      cancel: () => {
        this._selectionIndicatorTween = undefined;
      }
    });
  }

  /**
   * Animate the indicator to release the selection.
   */
  animateDepart() {
    if (isDefined(this._selectionIndicatorTween)) {
      if (!this._selectionIndicatorIsAppearing) {
        // Already disappearing, don't restart the animation.
        return;
      }
      this._selectionIndicatorTween.cancelTween();
      this._selectionIndicatorTween = undefined;
    }
    this._selectionIndicatorIsAppearing = false;
    this._selectionIndicatorTween = this._tweens.add({
      startObject: {
        scale: 1.0,
        opacity: 1.0
      },
      stopObject: {
        scale: 1.5,
        opacity: 0.0
      },
      duration: 0.8,
      easingFunction: EasingFunction.EXPONENTIAL_OUT,
      update: value => {
        runInAction(() => {
          this.opacity = value.opacity;
          this.transform = "scale(" + value.scale + ") rotate(0deg)";
        });
      },
      complete: () => {
        this._selectionIndicatorTween = undefined;
      },
      cancel: () => {
        this._selectionIndicatorTween = undefined;
      }
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "position", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showSelection", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "transform", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "opacity", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1.0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_screenPositionX", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return offScreen;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_screenPositionY", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return offScreen;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _class);
export { CesiumSelectionIndicator as default };